<template>
  <div>
    <div class="uk-section uk-section-default uk-section-small">
      <div class="uk-grid uk-grid-small uk-text-center" uk-grid>
        <div class="uk-width-1-1">
          <h3>Search products</h3>
        </div>
        <div class="uk-width-1-1">
          <form action="" v-on:submit.prevent="itemSearch">
            <div class="uk-margin">
              <div class="uk-inline">
                <input type="text" class="uk-input" minlength="3" v-model="searchQuery" placeholder="Enter the upc or sku code" required>
              </div>
              <button class="uk-button uk-button-primary">
                <i uk-icon="icon: search"></i>
              </button>
            </div>
          </form>
        </div>
        <div class="uk-width-1-1">
          <div class="uk-child-width-1-1@s uk-child-width-1-3@m uk-child-width-1-3@l uk-child-width-1-3@xl uk-grid-small uk-grid-match" uk-grid>
            <div>
              <div class="uk-card uk-card-default uk-card-body uk-box-shadow-small uk-box-shadow-hover-large">
                <h3 class="uk-card-title">Total number of products</h3>
                <p>{{ analytics.total_product_counts }}</p>
              </div>
            </div>
            <div>
              <div class="uk-card uk-card-primary uk-card-body uk-box-shadow-small uk-box-shadow-hover-large">
                <h3 class="uk-card-title">Total number of items</h3>
                <p>{{ analytics.total_items_count }}</p>
              </div>
            </div>
            <div>
              <div class="uk-card uk-card-secondary uk-card-body">
                <h3 class="uk-card-title">Total number of daily transactions</h3>
                <p>{{ analytics.total_daily_transactions }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data () {
      return {
        searchQuery: '',
        analytics: {
          total_product_counts: 0,
          total_daily_transactions: 0,
          total_user_counts: 0,
          total_items_count: 0,
        },
      }
    },
    activated() {
      this.getAnalytics();
    },
    mounted() {
      this.getAnalytics();
    },
    methods: {
      itemSearch() {
        this.$router.push({name: 'Search', query: {query: this.searchQuery}});
      },
      getAnalytics() {
        const self = this;

        self.$request().get("/analytics")
          .then(r => {
            const analytics = self.$request().successHandler(r).data.analytics;

            self.analytics.total_product_counts = analytics.total_product_counts;
            self.analytics.total_daily_transactions = analytics.total_daily_transactions;
            self.analytics.total_user_counts = analytics.total_user_counts;
            self.analytics.total_items_count = analytics.total_items_count;
          });
      }
    }
  }
</script>

<style scoped>
  .uk-card-title{
    font-size: 16px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue